export const siteSettings = {
  name: "Arcadia Trade",
  link: "https://arcadiatradepro.net",
  email: "support@arcadiatradepro.net",
  appLink: "https://app.arcadiatradepro.net",
};
